import React, {useContext, useEffect} from "react"

// util, data & context
import Util from "../../../util"
import Data from "../../../data"
import {CatalogueContext} from "../../../context/CatalogueContext"
import {ShopContext} from "../../../context/ShopContext";

// components
import Checkout from "./Checkout"
import CheckoutItems from "./CheckoutItems"
import Promocode from "./CheckoutPromocode"
import Warnings from "./Warnings"
import {RelatedActivities, Scaffolding} from "../../shared"


// styling
import "./Cart.scss"

function Cart() {
  // scroll to top when mounting
  useEffect(() => { Util.Scroll.scrollToTop()}, [])
  
  // context
  const catalogue = useContext(CatalogueContext)
  const shop = useContext(ShopContext)

  // catalogue not yet loaded its data?
  if(!catalogue.isReady) {
    return null
  }
  
  // render
  const combineInfo = <div id="v-cart-combine-info">
    Du möchtest mehrere Gechenke machen?<br/>Dann mach für jedes Geschenk eine Bestellung. So wird jede Überraschung persönlich und einzigartig.
  </div>
  return (
    <Scaffolding>
      <Checkout stepName="cart" title="Dein Warenkorb">
        <div id="v-cart">
          {shop.cartActivities.length > 1 ? combineInfo : null}
          <CheckoutItems showActions={true} showVoucher={true} showEta={false} showShipping={false} showShippingEta={false} showAddMore={true} />
          {/* 
          <div className="back-to-search">
            <div className="more-is-better">Eine Appentura-Überraschung ist besonders spannend, wenn du mehrere Aktivitäten zu einem Erlebnis kombinierst.</div>
            <Button kind="ok" onClick={() => setRedirectToSearch(true)}>Weitere Aktivität wählen</Button>
          </div>
          */}
          <Warnings />
          <Promocode />
        </div>
      </Checkout>
      <RelatedActivities title="Ergänze die Überraschung mit" adventure={Data.Cart.getAdventure()} /> 
    </Scaffolding>
  )
}

export default Cart